import { useContext, useEffect, useRef, useState } from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'
import { Plus } from '@hhgtech/icons/core'
import { Accordion, Box } from '@mantine/core'

import useStyles from './index.styles'
import { CtaBannerContext } from '../../context'
import { MultipleBanner } from '../../index.types'
import { ListingItem } from '../ListingItem'

export const AccordionGroup = () => {
  const { data } = useContext(CtaBannerContext)
  const { listing = [], expandAllCategories } = (data || {}) as MultipleBanner
  const { classes } = useStyles(undefined, {
    name: 'CtaBannerSection__MultipleImage__Item',
  })

  const defaultValue = expandAllCategories
    ? Array.from({ length: listing.length }, (_, i) => `group-${i}`)
    : ['group-0']

  const [values, setValues] = useState(defaultValue)

  // ✅ Mảng ref chứa nhiều carousel
  const carouselRef = useRef<any[]>([])

  // ✅ Mỗi khi accordion mở/đóng → reInit carousel đang mở
  const prevValues = useRef<string[]>(defaultValue)

  useEffect(() => {
    const newlyOpened = values.filter((v) => !prevValues.current.includes(v))
    newlyOpened.forEach((val) => {
      const idx = Number(val.replace('group-', ''))
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          carouselRef.current[idx]?.reInit?.()
        })
      })
    })
    prevValues.current = values
  }, [values])

  return (
    <Box className={classes.root}>
      <Accordion
        chevron={<Plus size={20} />}
        styles={{
          chevron: {
            '&[data-rotate]': {
              transform: 'rotate(45deg)',
            },
          },
        }}
        classNames={{
          label: classes.accordionLabel,
          control: classes.accordionControl,
          item: classes.accordionItem,
          content: classes.accordionContent,
        }}
        multiple
        defaultValue={defaultValue}
        onChange={(nextValues) => {
          setValues(nextValues)
        }}
      >
        {listing.map((group, index) => (
          <Accordion.Item value={`group-${index}`} key={index}>
            <Accordion.Control>
              <Text size="title2" weight="regular">
                {group.keyPillars?.name}
              </Text>
            </Accordion.Control>
            <Accordion.Panel>
              <ListingItem
                ref={(el) => (carouselRef.current[index] = el)}
                banners={group.banners}
                keepGridCol
              />
            </Accordion.Panel>
          </Accordion.Item>
        ))}
      </Accordion>
    </Box>
  )
}
